/* Vuex mutations types for module global */
export const TOGGLE_PENDING_ASYNC_STORE_ACTIONS = 'TOGGLE_PENDING_ASYNC_STORE_ACTIONS';
export const SET_PROPERTIES_OF_THE_PLATFORM = 'SET_PROPERTIES_OF_THE_PLATFORM';



// WEBPACK FOOTER //
// ./src/store/modules/global/mutations-types.js